import { BASE_FONT_SIZE } from '@/styles';

export const DOT_RADIUS = BASE_FONT_SIZE - 5;
export const circleStrokeWidth = 2;
